import createReactContext from 'create-react-context';
export var FormContext = createReactContext({
  labelAlign: 'right',
  vertical: false
});